<template>
    <div>
        <div style="margin-bottom:30px;margin-top:15px;">
            <el-row :gutter="30">
                <el-col :span="5">
                    <el-card shadow="always">
                        <div class="icon_area"><i class="el-icon-warning"></i></div>
                        <div class="span_area"><span>未完成评估数</span></div>
                        <div class="num_area_left"><span>{{ non_finished_num }}</span></div>
                    </el-card>
                </el-col>
                <el-col :span="5">
                    <el-card shadow="always">
                        <div class="icon_area"><i class="el-icon-success"></i></div>
                        <div class="span_area"><span>已完成评估数</span></div>
                        <div class="num_area_right"><span>{{ finished_num }}</span></div>
                    </el-card>
                </el-col>
                <el-col :span="5">
                    <el-card shadow="never" class="standard_tips">
                        <div><span style="font-size:18px;">达标标准：</span></div>
                        <div><span style="font-size:15px;">评估人不足5人，至少70%完成评估；</span></div>
                        <div><span style="font-size:15px;">评估人5人及以上，至少50%完成评估；</span></div>            
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div style="width:100%;height:40px;margin-bottom:10px;">
            <div class="top_buttons" style="float:left;">
                <el-button icon="el-icon-download" type="primary" @click="export_progress">导出进展</el-button>
                <el-button icon="el-icon-refresh" type="primary" @click="refresh_progress">刷新进展</el-button>
                <el-button icon="el-icon-message" type="warning" @click="send_emails">邮件跟催</el-button>
                <!-- <el-button icon="el-icon-copy-document" type="primary" @click="Import_users">导出进展 (评价维度)</el-button> -->
                <!-- <el-dialog title="导出进展" :visible.sync="dialogFormVisible" width="400px" :destroy-on-close="true" :close-on-click-modal="false">
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="选择公司">
                            <el-select v-model="form.selected_company" placeholder="请选择">
                                <el-option
                                v-for="item in form.company_list"
                                :key="item"
                                :label="item"
                                :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <div style="margin-top:20px;">
                            <el-button @click="cancle_export">取 消</el-button>
                            <el-button type="primary" @click="export_progress">确 定</el-button>
                        </div>
                    </el-form>
                </el-dialog> -->
            </div>
            <div class="search" style="float:right;">
                <el-form :inline="true" :model="formInline" @submit.native.prevent>
                <el-form-item>
                <el-input
                placeholder="请输入搜索信息"
                v-model="formInline.search_info"
                @keyup.native.enter="search"
                clearable>
                </el-input>
                </el-form-item>
                <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                </el-form-item>
                </el-form>
            </div>
        </div>
        <div style="margin-bottom:10px;">
            <el-alert
                :title="tips"
                type="success"
                show-icon>
            </el-alert>
        </div>
        <el-table
        :data="chengshu_results"
        style="width: 100%">
            <!-- <el-table-column prop="id" label="序号" min-width="5%"></el-table-column> -->
            <el-table-column type="index"></el-table-column>
            <el-table-column prop="assessee" label="被评估人" min-width="12%"></el-table-column>
            <el-table-column prop="email" label="邮箱" min-width="20%"></el-table-column>
            <el-table-column prop="company" label="公司" min-width="14%"></el-table-column>
            <el-table-column prop="department" label="部门" min-width="14%"></el-table-column>
            <el-table-column prop="self_evaluation" label="自评" min-width="10%">
                <template slot-scope="scope">
                    <div v-if="scope.row.self_evaluation=='未完成'" class="non_finished_status">{{ scope.row.self_evaluation }}</div>
                    <div v-if="scope.row.self_evaluation=='已完成'" class="finished_status">{{ scope.row.self_evaluation }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="superior_evaluation" label="上级评估" min-width="10%">
                <template slot-scope="scope">
                    <div v-if="scope.row.superior_evaluation=='未完成'" class="non_finished_status">{{ scope.row.superior_evaluation }}</div>
                    <div v-if="scope.row.superior_evaluation=='已完成'" class="finished_status">{{ scope.row.superior_evaluation }}</div>
                    <div v-if="scope.row.superior_evaluation=='不涉及'" class="not_involved">{{ scope.row.superior_evaluation }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="peer_evaluation" label="peer评估" min-width="10%">
                <template slot-scope="scope">
                    <span v-if="scope.row.peer_evaluation.split('/')[0]!=scope.row.peer_evaluation.split('/')[1]" 
                    class="non_finished_num">{{ scope.row.peer_evaluation }}</span>
                    <span v-if="scope.row.peer_evaluation.split('/')[0]==scope.row.peer_evaluation.split('/')[1]" 
                    class="finished_num">{{ scope.row.peer_evaluation }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="subordinate_evaluation" label="下级评估" min-width="10%">
                <template slot-scope="scope">
                    <span v-if="scope.row.subordinate_evaluation.split('/')[0]!=scope.row.subordinate_evaluation.split('/')[1]" 
                    class="non_finished_num">{{ scope.row.subordinate_evaluation }}</span>
                    <span v-if="scope.row.subordinate_evaluation.split('/')[0]==scope.row.subordinate_evaluation.split('/')[1]" 
                    class="finished_num">{{ scope.row.subordinate_evaluation }}</span>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin-top:10px;" v-if="chengshu_results.length > 0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageinfo.count"
                :page-sizes="pageinfo.page_sizes"
                :page-size="pageinfo.page_size"
                layout="total, sizes, prev, pager, next"
                :total="pageinfo.count">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import getdata from "@/api/getData.js";
import postdata from "@/api/postData.js";
export default {
    created() {
        // console.log('progress task id: ' + this.task_id);
        this.getProgressInfo();
    },
    data() {
        return {
            tips: 'peer评估和下级评估显示为：已完成数/总评估数。',
            non_finished_num: null,
            finished_num: null,
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 10,
                page_sizes: [1, 10, 20, 50, 100],
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            form: {
                company_list: [],
                selected_company: '',
            },            
            dialogFormVisible: false,
            chengshu_results: [
            //     {
            //     assessee: '张三',
            //     company: '',
            //     department: '部门A',
            //     self_evaluation: '已完成',
            //     superior_evaluation: '未完成',
            //     peer_evaluation: '0/7',
            //     subordinate_evaluation: '3/7',
            // },{
            //     assessee: '李四',
            //     company: '',
            //     department: '部门B',
            //     self_evaluation: '未完成',
            //     superior_evaluation: '已完成',
            //     peer_evaluation: '2/2',
            //     subordinate_evaluation: '1/3',
            // }
            ],
            template_file: {
                file_name: 'Assessment_progress.xlsx'
            },
        };
    },
    props: ['task_id'],
    methods: {
        search() {
            this.getProgressInfo(this.formInline.search_info);
        },
        refresh_progress() {
            this.getProgressInfo();
            this.$message({
                message: '刷新完成！',
                type: 'success',
                duration: 1500,
            })
        },
        getProgressInfo(query_info) {
            query_info = query_info||'';
            let params;
            params = {
                query_info: query_info,
                task_id: this.task_id,
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
            }
            getdata.getListP("getProgressInfo", params)
                .then(resp => {
                    if(resp.data.code == 200){
                        this.chengshu_results = resp.data.data;
                        this.pageinfo.count = resp.data.count;
                        this.finished_num = resp.data.finished_num;
                        this.non_finished_num = resp.data.unfinished_num;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            if(this.query_info==''){
                this.getProgressInfo();
            }else{
                this.getProgressInfo(this.query_info);
            }
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            if(this.query_info==''){
                this.getProgressInfo();
            }else{
                this.getProgressInfo(this.query_info);
            }
        },
        export_progress_by_users() {
            // 先从后台获取公司列表
            getdata.getList("getCompanyList")
                .then(resp => {
                    if(resp.data.code == 200){
                        this.form.company_list = resp.data.data;
                        this.form.selected_company = this.form.company_list[0];
                        // 获取到公司列表后，打开导出页面
                        this.dialogFormVisible = true;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        export_progress() {
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP("exportProgressByUsers", JSON.stringify(this.template_file), params)
              .then(resp => {
                this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        cancle_export() {
            this.dialogFormVisible = false;
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        send_emails() {
            this.$confirm('是否批量发送跟催邮件?', '通知', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params;
                params = {
                    task_id: this.task_id,
                }
                getdata.getListP("sendEmails", params)
                .then((resp) => {
                    if(resp.data.code == 200){
                        this.$message({
                            message: resp.data.message,
                            type: "success",
                        })
                    }else{
                        this.$message({
                            message: resp.data.message,
                            type: "error",
                            duration: 6000,
                            // showClose: true,
                        })
                    }})
                .catch(err => {
                    console.log(err);
                }) 
            }).catch( err => {
                console.log(err);
            })
        },
    }
};
</script>

<style scoped>
.top_buttons > .el-button {
    font-size: 16px;
    /* font-weight: bold; */
}
.search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
}
::v-deep .el-col-5 {
    width: 350px;
}
::v-deep .el-card__body {
    height: 70px;
    padding: 10px;
}
::v-deep .el-table__header {
    font-size: 16px;
}
::v-deep .el-form-item {
    margin-bottom: 0;
}
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
.el-icon-warning {
    color: #F56C6C;
    font-size: 23px;
}
.el-icon-success {
    color: #67C23A;
    font-size: 23px;
}
.icon_area {
    float: left;
    margin-top: 20px;
    margin-left: 25px;
}
.span_area {
    text-align: left;
    margin-left: 80px;
    font-size: 18px;
    font-weight: bold;
    color: #606266;
}
.num_area_left {
    text-align: left;
    margin-left: 80px;
    margin-top: 5px;
    font-size: 33px;
    font-weight: bold;
    color: #F56C6C;
}
.num_area_right {
    text-align: left;
    margin-left: 80px;
    margin-top: 5px;
    font-size: 33px;
    font-weight: bold;
    color: #67C23A;
}
.standard_tips {
    border: none;
    text-align: left;
    color: #606266;
}
.non_finished_status {
    font-size: 12px;
    background: #f56c6c;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.finished_status {
    font-size: 12px;
    background: #67C23A;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.not_involved {
    font-size: 12px;
    background: #909399;
    display: inline-block;
    white-space: nowrap;
    padding: 7px 15px;
    border-radius: 3px;
    line-height: 1;
    color: white;
}
.finished_num {
    font-weight: bold;
    font-size: 17px;
    color: #67C23A;
}
.non_finished_num {
    font-weight: bold;
    font-size: 17px;
    color: #f56c6c;
}
::v-deep .el-alert__title {
    font-size: 16px;
}
::v-deep .el-alert__content {
    text-align: left;
}
::v-deep .el-dialog__header {
    text-align: left;
}
</style>